<template>
  <div class="subscriptions">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            Subscriptions
          </div>
          <el-tabs v-if="isLeaderCompany" v-model="activeSubscriptionTab" @tab-click="handleClickSubscriptions">
            <el-tab-pane :label="$t('users_tab_subscriptions_plans')" name="subscriptions-plans">
              <SettingsSubscriptions ref="subscriptions"/>
            </el-tab-pane>
            <el-tab-pane :label="$t('users_tab_subscriptions_history')" name="subscriptions-history">
              <subscription-history ref="subscriptionHistory"/>
            </el-tab-pane>
          </el-tabs>
          <div v-else>
            {{`This company is temporarily unavailable. Please choose another company or contact the company owner at ${companyLeader && companyLeader.email}.`}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsSubscriptions from "../components/users/settingsSubscriptions";
import SubscriptionHistory from "../components/users/SubscriptionHistory";

export default {
  name: "Subscriptions",
  components: {
    SettingsSubscriptions,
    SubscriptionHistory,
  },
  data() {
    return {
      activeSubscriptionTab: 'subscriptions-plans',
    }
  },
  computed: {
    companyLeader(){
      return this.$store.getters.getRowDataUsers.filter(user => user.leader)[0]
    },
    user() {
      return this.$store.state.user
    },
    isLeaderCompany() {
      return this.companyLeader && this.user && this.user.user && this.companyLeader.uId === this.user.user.id
    }
  },
  async mounted() {
    await this.$store.dispatch('getRowDataUsers')
    this.$nextTick(() => {
      if (this.isLeaderCompany) {
        this.$refs.subscriptions.loadSubscriptionsList()
      }
    })
  },
  methods: {
    handleClickSubscriptions(tab, event) {
      switch(tab.name){
        case 'subscriptions-plans':
          this.$refs.subscriptions.loadSubscriptionsList();
          break;
        case 'subscriptions-history':
          this.$refs.subscriptionHistory.loadSubscriptionHistory();
          break;
      }
    },
  },
  watch: {
    isLeaderCompany(val) {
      this.$nextTick(() => {
        if (val) this.$refs.subscriptions.loadSubscriptionsList()
      })
    }
  }
}
</script>

<style lang="less" scoped>
.subscriptions {
  .content {
    display: flex;
    min-height: 100vh;
    padding-top: 50px;
    .wrapper{
      background: #fff;
      margin: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      .main-wrap {
        padding: 20px;
        width: 100%;
        .settings-header {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>

<style lang="less">
.header.subscription {
  .organisation-dropdown, .my-workday, .feedback-wrapper, .my-lists, .notification {
    display: none !important;
  }
}

</style>